import { render, staticRenderFns } from "./ForwarderSchedule4IPIT.vue?vue&type=template&id=0fb70709&scoped=true&"
import script from "./ForwarderSchedule4IPIT.vue?vue&type=script&lang=js&"
export * from "./ForwarderSchedule4IPIT.vue?vue&type=script&lang=js&"
import style0 from "./ForwarderSchedule4IPIT.vue?vue&type=style&index=0&id=0fb70709&prod&lang=less&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb70709",
  null
  
)

export default component.exports